import React from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { MuiXHelpers_createElement } from "../../fable_modules/Feliz.MuiX.DatePickers.6.9.2-alpha.6/Mui.fs.js";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { getLocale } from "../../Locale.js";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";

export function Activities_PlannedDatePicker_Z7A8C0D37(activities_PlannedDatePicker_Z7A8C0D37InputProps) {
    let value_4, elems;
    const onChange = activities_PlannedDatePicker_Z7A8C0D37InputProps.onChange;
    const plannedDateOpt = activities_PlannedDatePicker_Z7A8C0D37InputProps.plannedDateOpt;
    const ctx = reactApi.useContext(ctx_1);
    return MuiXHelpers_createElement(LocalizationProvider, [["adapterLocale", getLocale(ctx.Language)], ["localeText", ctx.Locale], (value_4 = AdapterDateFns, ["dateAdapter", value_4]), (elems = [MuiXHelpers_createElement(DateCalendar, toList(delay(() => append(singleton(["autoFocus", false]), delay(() => append(singleton(["readOnly", onChange == null]), delay(() => append(singleton(["disablePast", true]), delay(() => append(singleton(["value", plannedDateOpt]), delay(() => {
        const matchValue = onChange;
        if (matchValue != null) {
            const f = matchValue;
            return singleton(["onChange", (ev) => {
                console.debug("plannedDatePicker value", ev);
                f(ev);
            }]);
        }
        else {
            return empty();
        }
    })))))))))))], ["children", reactApi.Children.toArray(Array.from(elems))])]);
}

